import React, { useState } from "react";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { SelectTags } from "src/app/components/SelectTags/SelectTags";
import { translateMessage } from "src/app/methods/translateMessage";
import { useIntl } from "react-intl";
import CriteriaOptionSelector from "../CriteriaOptionSelector/CriteriaOptionSelector";
import METHODS from "../../../../../helpers/methods";

export const CreatorTagsFilter = ({
  creatorTags,
  selectedCreatorTags,
  setSelectedCreatorTags,
  creatorTagsOption,
  setCreatorTagsOption,
  disabled,
}) => {
  const intl = useIntl();

  const [searchTag, setSearchTag] = useState("");

  const items = creatorTags?.settings?.singleSelectOptions;

  if (!items) return null;

  const tagClick = (name) => {
    const item = items.find((i) => i.name === name);
    if (!item) return;

    const { value } = item;

    if (selectedCreatorTags.find((item) => item.value === value)) {
      setSelectedCreatorTags(
        selectedCreatorTags.filter((item) => item.value !== value),
      );
    } else {
      setSelectedCreatorTags([...selectedCreatorTags, { label: name, value }]);
    }
  };

  const feed =
    items
      .map((item) => item.name)
      .filter((tag) => METHODS.doesTextIncludeSearchTerm(tag, searchTag)) || [];

  const selectedItems =
    items.filter((item) =>
      selectedCreatorTags.find((tag) => tag.value === item.value),
    ) || [];

  const selectedNames = selectedItems.map((item) => item.name);

  return (
    <div
      className="creator-search-filters__content-wrapper"
      data-qa="filter_creator_tags"
    >
      <div className="audience-search__field">
        <div className="audience-search__input">
          <div className="idh-label">
            <IDHFormattedMessage
              id="front_exclude_results_with_tags"
              defaultMessage="Exclude results with tags"
            />
          </div>

          <div className="audience-search__input-wrapper">
            <input
              placeholder={translateMessage({
                intl,
                id: "front_keywords_topic_placeholder",
                defaultMessage: "Search keywords...",
              })}
              value={searchTag}
              onChange={(e) => setSearchTag(e.target.value)}
              data-cdt-input="creator-tags"
              disabled={disabled}
            />

            <CriteriaOptionSelector
              value={creatorTagsOption?.value}
              setValue={setCreatorTagsOption}
            />
          </div>
        </div>
      </div>

      <SelectTags
        feed={feed}
        values={selectedNames}
        setValue={tagClick}
        unsetValue={tagClick}
        clearValues={() => setSelectedCreatorTags([])}
        disabled={disabled}
        isExpandable
      />
    </div>
  );
};
